import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

const networkErrorCode = 445566;

const initialState = {
  currentError: null,
  currentMessage: null,
  lastShown: null,
  isSettingMessage: false
};

const messageStore = create(subscribeWithSelector((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setError: (sessionToken, code, message) => {
    let newError = {
      sessionToken: sessionToken,
      code: code,
      message: message
    };
    set({
      currentError: { ...newError }
    });
  },
  clearError: () => {
    let currentError = get().currentError;
    if (currentError) {
      if (get().currentError.code == networkErrorCode) {
        set({ currentError: null, lastShown: new Date() });
      } else {
        set({ currentError: null });
      }
    } else {
      set({ currentError: null });
    }
  },
  setMessage: (sessionToken, message) => {
    console.log("message", message);
    let newMessage = {
      sessionToken: sessionToken,
      message: message
    };
    set({
      currentMessage: { ...newMessage }
    });
  },
  clearMessage: () => {
    set({ currentMessage: null });
  }
})));

export default messageStore;